import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Typography,
  Box,
  LinearProgress,
  Tooltip,
  Badge,
} from "@mui/material";
import { Link } from "react-router-dom";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import LaunchIcon from "@mui/icons-material/Launch";
import AlarmIcon from "@mui/icons-material/Alarm";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ListAltIcon from "@mui/icons-material/ListAlt";
import GroupIcon from "@mui/icons-material/Group";
import axios from "axios";
import AuthService from "../../utils/AuthService";
import LeaderBoard from "../../components/User/LeaderBoard";
//import ApiMap from "../../utils/ApiMap";

function CourseLaunchBtn({ course }) {
  const [enrolling, setEnrolling] = useState(false);
  const [enrolled, setEnrolled] = useState(false);
  const navigate = useNavigate();
  console.log(
    "Role :",
    AuthService.isFaculty(course.id) ? "Faculty" : "Student"
  );

  async function enrollUser() {
    try {
      setEnrolling(true);
      const response = await axios.put(
        `/api/course/${course.id}/enroll`,
        null,
        AuthService.getAuthHeader()
      );
      setEnrolling(false);
      if (response.status === 205) setEnrolled(true);
    } catch (err) {
      setEnrolling(false);
      console.error(err);
    }
  }

  const handleOpenCourse = () => {
    localStorage.setItem("courseName", course.name);
    const storedData = localStorage.getItem(`lastVisitedMoudle_${course.id}`);
    const lastVisited = storedData ? JSON.parse(storedData) : null;
    console.log(lastVisited);
    if (lastVisited) {
      const { lessonId, chapterId, moduleId } = lastVisited;
      navigate(
        `/Modules/Course/${course.id}/Module/${moduleId}/Chapter/${chapterId}/Lesson/${lessonId}`
      );
    } else {
      navigate(`/Modules/Course/${course.id}`);
    }
  };

  if (course.enrolledOn && !course.enrollmentAccepted) {
    return (
      <Button variant="text" endIcon={<AlarmIcon />}>
        PENDING APPROVAL
      </Button>
    );
  }
  if (!course.enrolledOn) {
    return enrolled ? (
      <Button variant="contained" endIcon={<AlarmIcon />}>
        PENDING APPROVAL
      </Button>
    ) : enrolling ? (
      <Box>
        <Typography> Enrolling...</Typography>
        <LinearProgress />
      </Box>
    ) : (
      <Button
        variant="contained"
        onClick={enrollUser}
        endIcon={<ControlPointIcon />}
      >
        ENROLL
      </Button>
    );
  }
  return (
    <Button
      variant="contained"
      endIcon={<LaunchIcon />}
      onClick={handleOpenCourse}
    >
      OPEN
    </Button>
  );
}

function CourseAssignments({ courseId }) {
  const gradeDueCount = 1; // placeholder
  const missingAssignmentCount = 1;

  return (
    <Box display="flex" alignItems="center" gap={2} sx={{ mr: 2 }}>
      <Tooltip title="Assignments to Grade">
        <Badge badgeContent={gradeDueCount} color="primary">
          <Link
            to={`/Grade/course/${courseId}`}
            style={{ textDecoration: "none" }}
          >
            <AssignmentTurnedInIcon sx={{ color: "#8BC34A", fontSize: 24 }} />
          </Link>
        </Badge>
      </Tooltip>

      <Tooltip title="Students Missing Assignments">
        <Badge badgeContent={missingAssignmentCount} color="primary">
          <Link
            to={`/Assignment/missing/course/${courseId}`}
            style={{ textDecoration: "none" }}
          >
            <ErrorOutlineIcon sx={{ color: "#fa0558", fontSize: 24 }} />
          </Link>
        </Badge>
      </Tooltip>

      <Tooltip title="Course Grades">
        <Link
          to={`/coursegrades/${courseId}`}
          style={{ textDecoration: "none" }}
        >
          <ListAltIcon sx={{ color: "#2196F3", fontSize: 24 }} />
        </Link>
      </Tooltip>

      <Tooltip title="Course Members">
        <Link
          to={`/Members/Course/${courseId}`}
          style={{ textDecoration: "none" }}
        >
          <GroupIcon sx={{ color: "#607d8b", fontSize: 24 }} />
        </Link>
      </Tooltip>
    </Box>
  );
}

// function CourseContent({ course }) {
//   return (
//     <CardContent sx={{ pt: 1 }}>
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//         {course.description}
//       </Typography>
//       {course.enrollmentAccepted && (
//         <Box mt={2}>
//           <LeaderBoard courseId={course.id} />
//         </Box>
//       )}
//     </CardContent>
//   );
// }

export default function CourseCard({ courses }) {
  if (!courses) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <Typography>Loading...</Typography>
        <LinearProgress />
      </Box>
    );
  }

  return courses.map((course) => (
    <Card
      key={course.id}
      sx={{
        maxWidth: 360,
        width: "100%",
        margin: "8px",
        boxShadow: "rgba(2, 2, 2, 0.19) 0px 4px 12px",
      }}
    >
      <CardHeader
        title={
          <Typography variant="h4" sx={{ paddingLeft: 1, fontWeight: 500 }}>
            {course.name}
          </Typography>
        }
      />
      <CardActions sx={{ display: "flex", alignItems: "center", px: 2 }}>
        {AuthService.isFaculty(course.id) && (
          <CourseAssignments courseId={course.id} />
        )}

        <Box sx={{ flexGrow: 1 }} />
        <CourseLaunchBtn course={course} />
      </CardActions>
      <Link
        to={`/Modules/Course/${course.id}`}
        state={{ courseName: course.name }}
      >
        <Box
          component="img"
          sx={{ height: 200, width: "100%" }}
          src={course.mediaUrl}
          alt={course.name}
        />
      </Link>
      <CardContent>
        <Typography variant="body1">{course.description}</Typography>
        {/* Inject LeaderBoard Here */}
        <LeaderBoard courseId={course.id} />
      </CardContent>
    </Card>
  ));
}
